/* =======================================================
   MARKETPLACE TIME ZONES
   One IANA time zone per marketplace country (the main business zone for
   countries that span several, e.g. US → New York). Shared by the header
   clock and the dashboard's "orders by hour" chart so both agree.
======================================================= */

const COUNTRY_TIMEZONES: Record<string, string> = {
  US: "America/New_York",
  CA: "America/Toronto",
  MX: "America/Mexico_City",
  BR: "America/Sao_Paulo",
  GB: "Europe/London",
  UK: "Europe/London",
  DE: "Europe/Berlin",
  FR: "Europe/Paris",
  IT: "Europe/Rome",
  ES: "Europe/Madrid",
  NL: "Europe/Amsterdam",
  SE: "Europe/Stockholm",
  PL: "Europe/Warsaw",
  TR: "Europe/Istanbul",
  AE: "Asia/Dubai",
  SA: "Asia/Riyadh",
  IN: "Asia/Kolkata",
  JP: "Asia/Tokyo",
  SG: "Asia/Singapore",
  AU: "Australia/Sydney",
  EG: "Africa/Cairo",
  ZA: "Africa/Johannesburg",
  BE: "Europe/Brussels",
};

export const getBrowserTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

/** The marketplace's zone, or undefined when the country isn't mapped. */
export const findMarketplaceTimezone = (
  countryCode: string | undefined,
): string | undefined =>
  countryCode ? COUNTRY_TIMEZONES[countryCode.toUpperCase()] : undefined;

/** The marketplace's zone, falling back to the browser's. */
export const getMarketplaceTimezone = (countryCode: string | undefined) =>
  findMarketplaceTimezone(countryCode) ?? getBrowserTimezone();

/** Short zone name at `date`, e.g. "EDT", "GMT+3". */
export const getTimezoneShortName = (timezone: string, date = new Date()) =>
  new Intl.DateTimeFormat("en", { timeZoneName: "short", timeZone: timezone })
    .formatToParts(date)
    .find((p) => p.type === "timeZoneName")?.value ?? "";
